// extracted by mini-css-extract-plugin
export default {"inputNumber":"AdminTrapImagePage_inputNumber__PPX-I","date":"AdminTrapImagePage_date__1Lkoy","buttons":"AdminTrapImagePage_buttons__uTjcF"};